// Panel izquierdo de la lección: 3 items de vocabulario con palabra + fonética + imagen.

import { Icon } from '@/components/atoms/Icon';
import type { VocabItem } from '@/services/lessons';
import { safeHtml } from '@/utils/safeHtml';
import styles from './VocabPanel.module.scss';

interface VocabPanelProps {
  items: VocabItem[];
}

export function VocabPanel({ items }: VocabPanelProps) {
  if (items.length === 0) {
    return (
      <aside className={styles.panel}>
        <h3 className={styles.title}>Vocabulary</h3>
        <p className={styles.muted}>Sin vocabulario para esta lección.</p>
      </aside>
    );
  }
  return (
    <aside className={styles.panel} aria-label="Vocabulary">
      <h3 className={styles.title}>
        <Icon name="book" size={16} /> Vocabulary
      </h3>
      <ul className={styles.list}>
        {items.map((it) => (
          <li key={it.position} className={styles.item}>
            <div className={styles.row}>
              {it.phonetic_image_url ? (
                <img src={it.phonetic_image_url} alt="" className={styles.thumb} />
              ) : (
                <span className={styles.thumb}>
                  <Icon name="book" size={20} />
                </span>
              )}
              <div className={styles.text}>
                <div className={styles.word}>{it.word ?? '—'}</div>
                {it.phonetic && <div className={styles.phonetic}>/{it.phonetic.replace(/^\/|\/$/g, '')}/</div>}
              </div>
            </div>
            {it.learn_text && (
              <div className={styles.learn}>
                {it.learn_image_url && (
                  <img src={it.learn_image_url} alt="" className={styles.learnImage} />
                )}
                <div className={styles.richText} dangerouslySetInnerHTML={{ __html: safeHtml(it.learn_text) }} />
              </div>
            )}
          </li>
        ))}
      </ul>
    </aside>
  );
}
